export default "__VITE_ASSET__cb387754__"